import {AddSchema} from "mobx-graphlink";
import {GetValues, GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";

export class EngineConfig_Media {
	enabled: boolean;

	jumpForward_triggerSet: TriggerSet;
	jumpBackward_triggerSet: TriggerSet;
	increasePlaySpeed_triggerSet: TriggerSet;
	decreasePlaySpeed_triggerSet: TriggerSet;
	togglePlaying_triggerSet: TriggerSet;
	markDesyncCaught_triggerSet: TriggerSet;

	jumpSeconds: number;
	speedStep: number;
	desync_enabled: boolean;
	desync_startTimeMin: number; // in minutes
	desync_startTimeMax: number; // in minutes
	desync_panDelayMin: number; // in seconds
	desync_panDelayMax: number; // in seconds

	mediaPools: MediaPool[];
}
AddSchema("EngineConfig_Media", {
	properties: {
		enabled: {type: "boolean"},

		jumpForward_triggerSet: {$ref: "TriggerSet"},
		jumpBackward_triggerSet: {$ref: "TriggerSet"},
		increasePlaySpeed_triggerSet: {$ref: "TriggerSet"},
		decreasePlaySpeed_triggerSet: {$ref: "TriggerSet"},
		togglePlaying_triggerSet: {$ref: "TriggerSet"},
		markDesyncCaught_triggerSet: {$ref: "TriggerSet"},

		jumpSeconds: {type: "number"},
		speedStep: {type: "number"},
		desync_enabled: {type: "boolean"},
		desync_startTimeMin: {type: "number"},
		desync_startTimeMax: {type: "number"},
		desync_panDelayMin: {type: "number"},
		desync_panDelayMax: {type: "number"},

		mediaPools: {type: "array", items: {$ref: "MediaPool"}},
	},
});

export class MediaPool {
	constructor(data?: Partial<MediaPool>) { Object.assign(this, data); }

	name = "";
	enabled = true;
	type = MediaPoolType.audio;

	// if audio/video
	volume = .05;
	path = "";
}
AddSchema("MediaPool", {
	properties: {
		name: {type: "string"},
		enabled: {type: "boolean"},
		type: {$ref: "MediaPoolType"},

		volume: {type: "number"},
		path: {type: "string"},
	},
});

export enum MediaPoolType {
	audio = "audio",
}
AddSchema("MediaPoolType", {enum: GetValues(MediaPoolType)});